var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBestSub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0216 35.9991C27.9747 35.9991 36.0433 27.9404 36.0433 17.9996C36.0433 8.05867 27.9747 0 18.0216 0C8.06856 0 0 8.05867 0 17.9996C0 27.9404 8.06856 35.9991 18.0216 35.9991Z",
    fill: "url(#paint0_linear_2366_3188)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.895 22.25C21.895 22.25 18.5549 24.2791 14.1465 22.25",
    stroke: "#33160E",
    strokeWidth: 1.64614,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1301 11.9118C32.3331 13.4414 31.5574 14.9824 30.7177 16.4893C30.2532 17.3223 29.5741 18.0005 28.8623 18.6405C28.1292 19.2989 27.2157 19.445 26.2993 19.5827C25.1074 19.7601 23.9324 19.7246 22.7902 19.2634C21.5314 18.7568 20.7131 17.799 20.0326 16.688C19.5822 15.9558 19.2555 15.1626 18.8975 14.3836C18.7156 13.9905 18.5394 13.5861 17.9612 13.6443C17.697 13.6713 17.5151 13.7507 17.3716 13.965C17.1045 14.3637 16.9497 14.8135 16.7522 15.2449C16.2621 16.3176 15.6995 17.345 14.8541 18.1893C13.6579 19.3854 12.1733 19.7558 10.5309 19.665C9.86889 19.6295 9.21962 19.5046 8.5732 19.3684C7.69804 19.1854 7.07862 18.5993 6.49045 17.9892C5.55563 17.0186 4.84243 15.8991 4.34945 14.6433C4.017 13.7905 3.4402 13.0696 3.05661 12.2424C2.85203 11.8011 2.60908 11.374 2.58777 10.8717C2.56646 10.3722 2.72842 10.1366 3.21146 10.0075C4.15623 9.75636 5.12231 9.75778 6.08839 9.80744C7.59433 9.88407 9.10171 9.96637 10.5849 10.2615C11.2583 10.3963 11.9289 10.5467 12.6009 10.69C12.9831 10.7922 13.3652 10.8972 13.7474 10.9951C14.6268 11.2221 15.421 11.6266 16.1953 12.0948C17.3318 12.7802 18.5636 12.8767 19.6817 12.1658C21.2089 11.1923 22.9166 10.8277 24.6257 10.4289C25.3574 10.2573 26.1047 10.1537 26.8449 10.0189C28.1718 9.91954 29.4988 9.80886 30.83 9.78757C31.4409 9.77622 32.0404 9.85285 32.6385 9.95217C32.8999 9.99474 33.1471 10.0856 33.3361 10.2885C33.5961 10.8717 33.3972 11.3995 33.1301 11.9118Z",
    fill: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2366_3188",
    x1: 18.0216,
    y1: 0,
    x2: 18.0216,
    y2: 35.9991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.645833,
    stopColor: "#FECE47"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestSub);
export default __webpack_public_path__ + "static/media/bestSub.36c0d5ef2bc23a6aaf52cf800948d07c.svg";
export { ForwardRef as ReactComponent };